<template>
  <div class="search-drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">{{ title }}</h3>
      </div>
      <div class="col-md-7 align-self-center">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
          <li class="breadcrumb-item active">{{ title }}</li>
        </ol>
      </div>
    </div>

    <div class="row">
      <div class="col-12">

        <div v-if="!result" class="card">
          <div class="card-body align-self-center" style="width: 500px;">
            <form v-on:submit.prevent class="form-material">
              <div class="row">
                <div class="col-md-12 col-lg-12 p-0">
                  <div class="m-2">
                    <p>* This form will alert the Wingz technical team. Please provide as much information as possible to enable streamline the troubleshooting process.</p>
                    <textarea v-model="message" class="form-control" placeholder="Please describe the issue that you're having." style="width:100%; height: 500px; border:dotted 2px orange; border-radius: 8px; padding: 1rem;"></textarea>
                  </div>
                </div>
              </div>

              <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot=true style="border:dotted 2px grey; border-radius: 8px;"
                            v-on:vdropzone-error="vUploadError"
                            v-on:vdropzone-success="vdropzoneSuccess"
              >
                <div class="dropzone-custom-content">
                  <h3 class="dropzone-custom-title">Drag and drop to upload content!</h3>
                  <div class="subtitle">...or click to select a file from your computer</div>
                </div>
              </vue-dropzone>

              <div class="col-2 submit-button" style="margin: 0 auto; padding: 0;">
                <button v-on:click="sendMessage()" class="btn btn-danger waves-effect waves-light m-t-10">Send</button>
              </div>
            </form>
          </div>
        </div>

        <div v-if="result" class="card">
          <div class="card-body align-self-center" style="width: 500px;">
            <form v-on:submit.prevent class="form-material">
              <div class="row">
                <div class="col-md-12 col-lg-12 p-0">
                  <div class="m-2">
                    <p v-html="result"></p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Report Emergency',
    },
    name: 'ReportEmergency',
    data () {
      return {
        title: 'Report Emergency',
        data: {
          rides: [],
          filteredRides: [],
          sortedRides: [],
          resultColumns: ["ID", "Status code", "User", "Method", "URL", "APP name", "APP platform", "APP version", "Time spent", "Created at",],
          filters: {},
        },
        message: "Platform:\n\n" +
          "Operating System:\n\n" +
          "Browser:\n\n" +
          "URL or app screen:\n\n" +
          "Who is affected?\n\n" +
          "Number of users:\n\n" +
          "Email addresses/names of affected users:\n\n" +
          "============ Description ============\n\n" +
          "Steps to reproduce:\n\n" +
          "Expected result:\n\n" +
          "Actual result:\n\n" +
          "Notes:\n\n",
        isLoading: false,
        result: null,
        dropzoneOptions: {
          url: process.env.API_BASE_URL_CS + 'images/',
          thumbnailWidth: 150,
          maxFilesize: 2.5,
          addRemoveLinks: true,
          headers: {
            "Authorization": "jwt " + this.getUser().token
          }
        },
        imageLinks: [],
      }
    },
    components: {
      Loading,
      vueDropzone: vue2Dropzone
    },
    methods: {
      sendMessage: function (page) {
        if(!this.message) {
          alert("Please describe the issue that you're having.");
          return
        }

        this.isLoading = true
        this.$http
          .post(process.env.API_BASE_URL_CS + 'report-emergency/', {
            "message": this.imageLinks.length == 0 ? ("============ Summary ============\n\n" + this.message) : ("============ Summary ============\n\n" + this.message + '============ Screenshots ============\n\n' + this.imageLinks.join("\n"))
          })
          .then(response => {
            console.log(response)
            this.result = "Thank you for submitting your request to the technical support team. You will be contacted as soon as possible."
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      vUploadError: function (file, message, xhr) {
        console.error(message)
      },
      vdropzoneSuccess: function (file, response) {
        this.imageLinks.push(response.url)
      },
    },
    mounted () {
    },
    created () {
      // document.title = "Wingz Support | Driver Search";
      this.message = "Submit Date: " + new Date().toISOString() + "\n\n" + "Reporter: " + this.getUser().name_first + ' ' + this.getUser().name_last + "\n\n" + this.message
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
</style>



// WEBPACK FOOTER //
// src/components/ReportEmergency.vue